import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PostItemListWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
  border-radius: 16px;
  background: ${({ theme }) => theme.colors.white};
  flex: 1;
  overflow-y: auto;
  max-height: calc(100vh - 220px);
`;

export const CenterWrapper = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 220px);
  justify-content: center;
  align-items: center;
`;

export const TabWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
`;
